import SliderFrameMacStraight from './SliderFrameMacStraight'

export default SliderFrameMacStraight
